import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useRouteMatch } from 'react-router-dom'
import { faEdit, faClipboardList } from '@fortawesome/free-solid-svg-icons'
const ListAll = (props) => {
	const [customers, setCustomers] = useState([])
	const [filteredCustomer, setFilteredCustomer] = useState([])
	useEffect(() => {
		let customersLength = props.data.customers.length
		let tablesLength = props.data.tables.length
		if (
			customersLength > 0 &&
			tablesLength > 0 &&
			customersLength === tablesLength
		) {
			setCustomers(
				props.data.customers
					.map((data) => {
						let table = props.data.tables.find(
							(user) => user.uid === data[0]
						)
						return {
							uid: data[0],
							firstName: data[1].firstName,
							lastName: data[1].lastName,
							phoneNo: data[1].phoneNo,
							email: data[1].email,
							tableNumber: table.number,
						}
					})
					.sort((a, b) =>
						a.tableNumber > b.tableNumber
							? 1
							: b.tableNumber > a.tableNumber
							? -1
							: 0
					)
			)
		}
	}, [props.data.tables, props.data.customers])
	useEffect(() => {
		setFilteredCustomer(customers)
	}, [customers])
	const handleSearchCustomer = (table) => {
		if (table) {
			let results = customers.find(
				(customer) => customer.tableNumber === Number(table)
			)
			if (results) {
				setFilteredCustomer([results])
			} else {
				setFilteredCustomer([])
			}
		} else {
			setFilteredCustomer(customers)
		}
	}
	return (
		<>
			<section>
				<input
					inputmode="numeric"
					placeholder="Sök bordsnummer"
					onChange={(e) => handleSearchCustomer(e.target.value)}
				/>
			</section>
			<section>
				{filteredCustomer.length > 0
					? filteredCustomer.map((customer) => (
							<div class="flex-outer-container">
								<div class="flex-items">{customer.tableNumber}</div>
								<div class="flex-items">
									<div class="flex-inner-container">
										<div>
											{customer.firstName} {customer.lastName}
										</div>
										<div>{customer.phoneNo}</div>
										<div>{customer.email}</div>
									</div>
								</div>
								<div class="flex-items">
									
									<Link className='ReportButton' to={`/report/${customer.uid}`}>
										<FontAwesomeIcon
											title="Editera"
											icon={faClipboardList}
										/>
									</Link>
								</div>
							</div>
					  ))
					: null}
			</section>
		</>
	)
}
export default ListAll
/*


<div className='parent'>
					<div className='div1'>{customer.tableNumber}</div>
					<div className='div2'>
						{customer.firstName} {customer.lastName}
					</div>
					<div className='div3'>{customer.phoneNo}</div>
					<div className='div4'>{customer.email}</div>
					<div className='div5'>
						<Link to={`/report/${customer.uid}`}>
							<FontAwesomeIcon title='Editera' icon={faClipboardList} /> Rapport
						</Link>
					</div>
				</div>
		<Link to={`/report/${customer.uid}`}>
							<FontAwesomeIcon title='Editera' icon={faEdit} />
						</Link>
*/
